module.exports = __webpack_public_path__ + "static/img/img_tip3.a5ad8090.png";